import { gql } from '@apollo/client'

export type UpcDictEntry = {
  __typename?: 'UpcDictEntry'
  upc: string
  matches: string[]
}

export type GetUpcDictQuery = {
  upcDict: UpcDictEntry[]
}

export type GetUpcDictQueryVariables = {
  upcs: string[]
}

export const GET_UPC_DICT = gql`
  query UPCDict($upcs: [String!]!) {
    upcDict(upcs: $upcs) {
      upc
      matches
    }
  }
`
